module.exports = __webpack_public_path__ + "static/media/petra-obojes.31e1cab5.jpg";